import { ReactElement, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRightOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { Card, Row, Col, Alert, Button } from "antd";
import {  CHNAGE_LANGUAGE } from "../../redux/constants";
import { getAuthState, getBookingState, getAppState } from "../../redux/selectors";
import Logo from "../../assets/images/setpoint-logo.png";
import backgroundImage from "../../assets/images/setpoint-landing.png";
import Loading from "../../components/Loading";

export function Shop(): ReactElement {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { currentUser, emailVerified } = useSelector(getAuthState);
  const { isShareBooking, shareBookingTime, shareBookingDuration, shareBookingCourt, preBranch, preBookingDate } = useSelector(getBookingState);
  const { locale } = useSelector(getAppState);

  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [error, setError] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [showError, setShowError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [userCount, setUserCount] = useState<number>(0);
  
  const { productId } = useParams<{ productId: string }>();

  useEffect(() => {
    
  }, [currentUser]);
  
  const onChangeLanguage = (code: string) => {
    dispatch({
      type: CHNAGE_LANGUAGE,
      payload: code
    })
    i18n.changeLanguage(code);
  }

  return (
    <Row className="auth-container" style={{ alignItems:"flex-start" }}>
      <div className="landing-language-select-container" style={{ zIndex : 20 }}>
        <Button className="language-selector" onClick={() => onChangeLanguage(locale === "en" ? "ar" : "en")}>{t("common.language")}</Button>
        <Button className="language-selector" onClick={() => history.push("/shop")}>{t("menu.shop")}</Button>
        <Button className="language-selector" onClick={() => history.push("/login")}>{t("menu.login")}</Button>
      </div>
      <div className="landing-container">
        <div className="section">
          <img src={backgroundImage} alt="" className="top-section-background-image"/>
          <div className="top-section-title-container">
            <img src={Logo} alt="Logo" className="auth-logo" style={{ marginTop : 20}} />
            {/* <h2 className="top-section-title">{t("auth.welecome_community")}</h2> */}
            {/* <p className="top-section-sub-title">{t("auth.find_your_slot")}</p> */}
          </div>
        </div>
        <Row style={{ marginTop : 80,padding:10}} gutter={8} className="section">
            <Col span="24">
                <Row justify="center" gutter={[30,25]}>
                    <Col xs={24} sm={24} md={12} lg={16} xl={10}>
                        <Row>
                            <Col span="12" style={{backgroundColor:"#000d5f",padding:15}} >
                                <h2 style={{color:"white"}}>Club Shop</h2>
                                <p style={{color:"white"}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                                <Button onClick={()=> history.push("/shop/club")} type="primary" icon={<ArrowRightOutlined />}>
                                    SHOP NOW!
                                </Button>
                            </Col>
                            <Col span="12">
                                <img alt="" style={{filter:"grayscale(1)"}} height="100%"  width="100%" src="https://firebasestorage.googleapis.com/v0/b/setpoint-62e00.appspot.com/o/clubs%2Fundefined%2Fjust%20padel.jpg?alt=media&token=3ec98290-e338-4d81-96c2-198404bfa56a" />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={16} xl={10}>
                        <Row>
                            <Col span="12" style={{backgroundColor:"#000d5f",padding:15}} >
                                <h2 style={{color:"white"}}>Community Shop</h2>
                                <p style={{color:"white"}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                                <Button onClick={()=> history.push("/shop/community")} type="primary" icon={<ArrowRightOutlined />}>
                                    SHOP NOW!
                                </Button>
                            </Col>
                            <Col span="12">
                                <img alt="" style={{filter:"grayscale(1)"}} height="100%"  width="100%" src="https://firebasestorage.googleapis.com/v0/b/setpoint-62e00.appspot.com/o/clubs%2Fundefined%2Fjust%20padel.jpg?alt=media&token=3ec98290-e338-4d81-96c2-198404bfa56a" />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
      </div>
      <div className="contact-us-container">
        <span>{t("menu.contact_us")}: </span>
        <a href="mailto:hi@setpointapp.com" target="_blank" rel="noreferrer">hi@setpointapp.com</a>
      </div>
      { loading && <Loading />}
    </Row>
  );
}
